import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import SDXModalDialog from 'lib/generic/SDXModalDialog';
import {
	validatePhoneNumber,
	createOpenHoursConfig,
	isOpen,
	formatCloseTime,
	getValidSanitizePhoneNumber } from './helpers';
import { ICallFromNetCallRequest, ICallFromNetAvailabilityRequest, ICFNConfig, IDiceAccepanceResponse } from './models';
import { initNewModules, isSwissVisitor, sanitizePhone } from 'lib/util/helpers';

const CSS_CLASS_HIDDEN = 'hidden';
const CSS_CLASS_ERROR = 'error';
const AJAX_TIMEOUT = 10000;
const DISPLAY_OPTION_HOTLINE = 'hotline';
const DISPLAY_OPTION_BUTTON = 'button';

function hideLoader($ctx : JQuery) {
	$ctx.find('.loader-holder').addClass(CSS_CLASS_HIDDEN);
}
function showLoader($ctx : JQuery) {
	$ctx.find('.loader-holder').removeClass(CSS_CLASS_HIDDEN);
}
function showCFN($ctx : JQuery) {
	$ctx.find('.cfn-open').removeClass(CSS_CLASS_HIDDEN);
}
function hideCFN($ctx : JQuery) {
	$ctx.find('.cfn-open').addClass(CSS_CLASS_HIDDEN);
}
function isAvailable(openingHours : string) : boolean {
	const config = createOpenHoursConfig(openingHours);

	return isOpen(config);
}
function showHotlineOpen($ctx : JQuery, publicNumber : string) {
	const formattedNumber = publicNumber.replace(/^(\+410?)([\d]{3})([\d]{3})([\d]{3})$/, '0$2 $3 $4');
	$ctx.find('div:not(.abroad-display, .check-available-error) > .hotline-info .hotline-number').text(formattedNumber);
	$ctx.find('.hotline-open').removeClass(CSS_CLASS_HIDDEN);
}
function hideHotlineOpen($ctx : JQuery) {
	$ctx.find('div:not(.abroad-display, .check-available-error) > .hotline-info .hotline-number').text('');
	$ctx.find('.hotline-open').addClass(CSS_CLASS_HIDDEN);
}
function hideHotlineClosed($ctx : JQuery) {
	$ctx.find('.hotline-close').addClass(CSS_CLASS_HIDDEN);
}
function displayError($ctx : JQuery, considerDisplayOptions = false, displayOption : string, $buttonLink : JQuery) {
	$ctx.removeClass('left right center');
	if (considerDisplayOptions) {
		if (displayOption === DISPLAY_OPTION_BUTTON) {
			$buttonLink.removeClass(CSS_CLASS_HIDDEN);
		} else if (displayOption === DISPLAY_OPTION_HOTLINE) {
			$ctx.find('.check-available-error').removeClass(CSS_CLASS_HIDDEN);
		}
	} else {
		$ctx.find('.check-available-error').removeClass(CSS_CLASS_HIDDEN);
	}
}
function hideError($ctx : JQuery) {
	$ctx.find('.check-available-error').addClass(CSS_CLASS_HIDDEN);
}

export default class CallFromNet extends Module {
	private $button! : JQuery;
	private $dialog! : JQuery;
	private $successDialog! : JQuery;
	private configuration! : ICFNConfig[];
	private hasMultipleTopics! : boolean;
	private ajaxUrlPrefix! : string;
	private activeTopicConfig! : ICFNConfig;
	private displayCFNCloseOption! : string;
	private displayOpeningHours! : boolean;
	private displayOpeningHoursAsTooltip! : boolean;
	private trackAction! : string;
	private trackLabel! : string;
	private trackLocation! : string;
	private trackCategory! : string;
	private trackLinkName! : string;
	private conversionCategory! : string;
	private conversionDetail! : string;
	private conversionClass! : string;
	private $buttonLink! : JQuery;

	public on(callback : Hook) {
		this.configuration = this.$ctx.data('configuration');

		if(!this.configuration) {
			this.$ctx.hide();
			this.log('Do not initialize component if configuration is missing');
			callback();

			return;
		}

		this.$dialog = this.$ctx.find('.callfromnet-dialog');
		this.$successDialog = this.$ctx.find('.callfromnet-dialog-success');
		this.hasMultipleTopics = this.configuration.length > 1;
		this.ajaxUrlPrefix = this.$ctx.data('ajax-url');
		this.displayCFNCloseOption = this.$ctx.data('display-options');
		this.displayOpeningHours = this.$ctx.data('display-oh');
		this.displayOpeningHoursAsTooltip = this.$ctx.data('display-oh-as-tooltip');
		this.trackAction = this.$ctx.data('track-action');
		this.trackLabel = this.$ctx.data('track-label');
		this.trackLocation = this.$ctx.data('track-location');
		this.trackCategory = this.$ctx.data('track-category');
		this.trackLinkName = this.$ctx.data('track-linkname');
		this.conversionCategory = this.$ctx.data('conversion-category');
		this.conversionDetail = this.$ctx.data('conversion-detail');
		this.conversionClass = this.$ctx.data('conversion-class');
		this.$buttonLink = this.$ctx.find('.button-link');

		if (!this.hasMultipleTopics) {
			this.$button = this.$ctx.find('.display-cfn .cfn-open .button, .display-cfn .cfn-open .link');
		} else {
			this.$button = this.$ctx.find('.cfn-multiple-configs .cfn-open .button, .cfn-multiple-configs .cfn-open .link');
		}

		hideLoader(this.$ctx);
		hideCFN(this.$ctx);
		hideHotlineOpen(this.$ctx);
		hideHotlineClosed(this.$ctx);
		hideError(this.$ctx);
		const $abroad = this.$ctx.find('.abroad-display');

		$abroad.addClass(CSS_CLASS_HIDDEN);

		this.$ctx.find('.button-link').addClass(CSS_CLASS_HIDDEN);
		if(this.$ctx.data('consider-abroad') && !isSwissVisitor()) {
			if (this.displayCFNCloseOption === DISPLAY_OPTION_BUTTON) {
				this.$buttonLink.removeClass(CSS_CLASS_HIDDEN);
			} else if (this.displayCFNCloseOption === DISPLAY_OPTION_HOTLINE) {
				$abroad.removeClass(CSS_CLASS_HIDDEN);
			}
		} else if (this.hasMultipleTopics) {
			showCFN(this.$ctx.find('.cfn-multiple-configs'));
			this.$dialog.find('.subtopics-holder').removeClass(CSS_CLASS_HIDDEN);
		} else {
			this.$dialog.find('.subtopics-holder').addClass(CSS_CLASS_HIDDEN);
			this.activeTopicConfig = this.configuration[0];
			this.chackAvailability(this.$ctx.find('.display-cfn'), true);
		}

		this.attachEvents();

		callback();
	}

	private attachEvents() {
		this.$button.on('click', this.startDialog.bind(this));
		this.$button.on('click', this.trackOpen.bind(this));
	}

	private startDialog() {
		SDXModalDialog.show({
			html: this.$dialog,
			title: this.$ctx.data('dialog-title'),
			width: this.hasMultipleTopics ? 680 : 490,
		});
		this.$dialog.removeClass(CSS_CLASS_HIDDEN);

		if (!this.hasMultipleTopics) {
			showCFN(this.$dialog);
		}
		/* When dialog is closed all handlers attached to its elements are
		removed so we need to attach events on every dialog show */
		this.$dialog.find('.button--secondary').click(() => SDXModalDialog.close());
		this.$dialog.find('form').submit(evt => {
			evt.preventDefault();
			this.submitForm();
		});
		const $subtopics = this.$dialog.find('.subtopics');
		$subtopics.find('li').each((i, li) => this.attachClickHandlerForSubtopic(i, $(li), $subtopics));
	}

	private attachClickHandlerForSubtopic(i : number, $li : JQuery, $subtopics : JQuery) {
		$li.find('label').on('click', (evt : JQuery.Event) => {
			$subtopics.find('li').each((_idx, elem) => { $(elem).removeClass('active'); });
			$li.addClass('active');

			this.activeTopicConfig = this.configuration[i];

			hideCFN(this.$dialog);
			hideHotlineOpen(this.$dialog);
			hideHotlineClosed(this.$dialog);

			this.trackSubtopics(this.activeTopicConfig.subtopicName || '');
			this.chackAvailability(this.$dialog);
			evt.stopPropagation();
		});
	}

	private chackAvailability($ctx : JQuery, considerDisplayOptions = false) {
		const data : ICallFromNetAvailabilityRequest = {
			segment: this.activeTopicConfig.segment,
		};
		if(this.activeTopicConfig.routingTarget) {
			data.routingTarget = this.activeTopicConfig.routingTarget;
		} else {
			data.subtopic = this.activeTopicConfig.subtopicKey;
			data.topic = this.activeTopicConfig.topicKey;
		}

		const postData = {
			data,
			timeout: AJAX_TIMEOUT,
			url: `${this.ajaxUrlPrefix}.contactavailable${this.activeTopicConfig.routingTarget ? '.v2' : ''}.json`,
		};
		const promise = $.post(postData) as JQuery.Promise3<
			any, any, never,
			JQuery.Ajax.SuccessTextStatus, JQuery.Ajax.ErrorTextStatus, never,
			any, any, never
		>;

		hideError($ctx);
		showLoader($ctx);

		return promise
		.then((res : IDiceAccepanceResponse) => {
			if(!res) {
				hideLoader($ctx);
				displayError($ctx, considerDisplayOptions, this.displayCFNCloseOption, this.$buttonLink);

				return 0;
			}
			const isCfnOpen = isAvailable(res.openhours);
			const isHotlineOpen = isAvailable(res.transferhours);

			hideLoader($ctx);
			if (isCfnOpen) {
				showCFN($ctx);
			} else {
				if (considerDisplayOptions) {
					if (this.displayCFNCloseOption === DISPLAY_OPTION_BUTTON) {
						this.$buttonLink.removeClass(CSS_CLASS_HIDDEN);
					} else if (this.displayCFNCloseOption === DISPLAY_OPTION_HOTLINE) {
						if (isHotlineOpen) {
							showHotlineOpen($ctx, res.publicnumber);
						} else {
							this.showHotlineClosed($ctx, res.transferhours);
						}
					}
				} else {
					if (isHotlineOpen) {
						showHotlineOpen($ctx, res.publicnumber);
					} else {
						this.showHotlineClosed($ctx, res.transferhours);
					}
				}
			}

			return 0;
		}, (err : JQuery.jqXHR) => {
			hideLoader($ctx);
			displayError($ctx, considerDisplayOptions, this.displayCFNCloseOption, $ctx.find('.button-link'));
			this.log(err.responseText);
		});
	}

	private track() {
		if (!(SCS && SCS.portal && SCS.portal.datalayer)) {
			return;
		}
		let location = this.trackLocation;
		if (this.hasMultipleTopics) {
			location += `_${this.activeTopicConfig.subtopicName || ''}`;
		}

		new SCS.portal.datalayer.Interaction()
			.withEvent(this.trackAction, this.trackLabel, location, this.trackCategory, this.trackLinkName)
			.withConversion(this.conversionCategory, this.conversionDetail, this.conversionClass)
			.track();
	}

	private trackOpen() {
		if (!(SCS && SCS.portal && SCS.portal.datalayer)) {
 			return;
 		}
		SCS.portal.datalayer.trackEvent(
			`${this.trackAction}_open`,
			this.trackLabel,
			this.trackLocation,
			this.trackCategory,
			this.trackLinkName,
		);
	}

	private trackSubtopics(subtopicLabel : string) {
		if (!(SCS && SCS.portal && SCS.portal.datalayer)) {
 			return;
 		}
		SCS.portal.datalayer.trackEvent(
			`${this.trackAction}_${subtopicLabel}`,
			this.trackLabel,
			this.trackLocation,
			this.trackCategory,
			this.trackLinkName,
		);
	}

	private submitForm() {
		this.$dialog.find('.phone-numbers input').each((_idx, elem) => {
			const $elem = $(elem);
			const $field = $elem.closest('.field');
			const	$fieldError = $field.find('.field-validation-error');
			const elemVal = $elem.val() as string;
			const isValid = validatePhoneNumber(sanitizePhone(elemVal));

			if ($elem.attr('aria-required') === 'true') {
				$field.addClass(CSS_CLASS_ERROR);
				$fieldError.removeClass(CSS_CLASS_HIDDEN);
				if (isValid && elemVal) {
					$field.removeClass(CSS_CLASS_ERROR);
					$fieldError.addClass(CSS_CLASS_HIDDEN);
				}
			} else {
				if (!isValid && elemVal) {
					$field.addClass(CSS_CLASS_ERROR);
					$fieldError.removeClass(CSS_CLASS_HIDDEN);
				} else {
					$field.removeClass(CSS_CLASS_ERROR);
					$fieldError.addClass(CSS_CLASS_HIDDEN);
				}
			}
		});

		const $form = this.$dialog.find('form');
		const phoneNo = ($form.find('input#numberToCall').val() as string).replace(/\s+/g, '');

		if (!$form.find('.field.error').length) {
			const postData = {
				data: this.getDataForSubmit(),
				timeout: AJAX_TIMEOUT,
				url: `${this.ajaxUrlPrefix}.contactrequest${this.activeTopicConfig.routingTarget ? '.v2' : ''}.json`,
			};
			this.track();
			const promise = $.post(postData) as JQuery.Promise3<
				any, any, never,
				JQuery.Ajax.SuccessTextStatus, JQuery.Ajax.ErrorTextStatus, never,
				any, any, never
			>;

			promise
			.then(() => {
				this.$successDialog.removeClass(CSS_CLASS_HIDDEN);
				this.$successDialog
					.find('.success-message')
					.text(this.$ctx.data('success-message').replace('${numberToCall}', phoneNo));
				SDXModalDialog.show({
					buttons: [{
						primary: true,
						title: this.$ctx.data('close-dialog-button-label'),
						type: 'close',
					}],
					html: this.$successDialog,
					title: this.$ctx.data('success-dialog-title'),
					width: this.hasMultipleTopics ? 680 : 490,
				});
			}, () => {
				SDXModalDialog.show({
					buttons: [{
						click: this.startDialog.bind(this),
						thin: true,
						title: this.$ctx.data('reset-dialog-button-label'),
					}],
					notification: 'alert',
					text: this.$ctx.data('error-message'),
				});
			});
		}
	}

	private getDataForSubmit() : ICallFromNetCallRequest {
		const $form = this.$dialog.find('form');

		const customerLineNumber = $form.find('input[name="customerLine"]').val() as string;
		const numberToCallVal = getValidSanitizePhoneNumber($form.find('input[name="numberToCall"]').val() as string) || '';
		const customerLineVal = getValidSanitizePhoneNumber(customerLineNumber) || '';

		const data : ICallFromNetCallRequest = {
			conversionclass : this.$ctx.data('conversion-class'),
			eventcategory: this.$ctx.data('track-category'),
			numbertocall: numberToCallVal,
			phonenumber: customerLineVal,
			segment: this.activeTopicConfig.segment,
			source: window.location.href.slice(0, 255),
		};
		if(this.activeTopicConfig.routingTarget) {
			data.routingTarget = this.activeTopicConfig.routingTarget;
		} else {
			data.subtopic = this.activeTopicConfig.subtopicKey;
			data.topic = this.activeTopicConfig.topicKey;
		}

		return data;
	}

	private showHotlineClosed($ctx : JQuery, openingHours : string) {
		if(this.displayOpeningHours) {
			const label = this.$ctx.data('closed-label');
			const lang = $('html').attr('lang') || 'de';
			if (!this.displayOpeningHoursAsTooltip) {
				$ctx.find('.hotline-closed .open-hours')
				.empty()
				.append(formatCloseTime(openingHours, label, lang));
			} else {
				const formatedTime = formatCloseTime(openingHours, label, lang).html();
				const str = `<div>${this.$ctx.data('open-time')} <span class="mod modCallOut sdx">${formatedTime}</span></div>`;
				$ctx.find('.hotline-closed')
				.empty()
				.append($(str));

				initNewModules($ctx.find('.hotline-closed'));
			}
		}
		$ctx.find('.hotline-close').removeClass(CSS_CLASS_HIDDEN);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/Tc.Module.CallFromNet.ts